import { Serializer } from 'serialize-ts';

import { InvalidParams } from '../models/invalid-params.model';

export class InvalidParamsSerializer implements Serializer<InvalidParams> {
  public serialize(invalidParams: InvalidParams): InvalidParams {
    return invalidParams;
  }

  public deserialize(invalidParams = []): InvalidParams {
    return invalidParams.reduce((memo: InvalidParams, invalidParam) => {
      const { name, ...otherInvalidParamProperties } = invalidParam;
      return {
        ...memo,
        [name]: otherInvalidParamProperties,
      };
    }, {});
  }
}
